// @flow
import styled from "styled-components";

export const Form = styled.div`
    & > div {
        margin: 20px;
        min-width: 70%;
    }
`;
export const Title = styled.div`
    font-size: 25px;
    font-weight: bold;
`;
export const Text = styled.div`
    font-size: 18px;
`;
export const Buttons = styled.div`
    & > button {
        margin-right: 20px;
    }
`;
export const SpinnerWrapper = styled.div`
    display: inline;
    position: absolute;
    margin-top: 2px;
`;



// WEBPACK FOOTER //
// ./src/feedback-dialog/styled.js